// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__PPOyh","name":"ConsentHeader_name__1XJ-d","birthday":"ConsentHeader_birthday__j3ZQO","skeleton":"ConsentHeader_skeleton__2qo1w"};